import { FieldSetStatus } from "../../form/Form";
import { kitFieldsForForm } from "../../form/kitFieldRegistry";

export const STATUS_POLL_INTERVAL_MS = 100;
export const STATUS_POLL_TIMEOUT_MS = 60_000;

export interface SubmitWatchOptions {
  intervalMs?: number;
  timeoutMs?: number;
}

/** The kit form's submit status as its registered inputs see it; undefined once the form is gone. */
export function kitFormStatus(formId: string): FieldSetStatus | undefined {
  return kitFieldsForForm(formId)[0]?.fieldSet.getStatus();
}

/**
 * Watches a kit form after a submit and reports the status it settled on. The kit exposes no
 * submit callback, but its status moves CREATED → SUBMITTING → SUBMIT_SUCCESS / SUBMIT_ERROR,
 * so polling the fieldSet is enough. The watch ends on the first settled status, when the form
 * unmounts (status undefined), or after the timeout (status still SUBMITTING). Returns a
 * function that stops the watch early.
 */
export function watchKitSubmit(formId: string, onSettled: (status: FieldSetStatus | undefined) => void, options: SubmitWatchOptions = {}): () => void {
  const intervalMs = options.intervalMs ?? STATUS_POLL_INTERVAL_MS;
  const timeoutMs = options.timeoutMs ?? STATUS_POLL_TIMEOUT_MS;
  const startedAt = Date.now();
  const timer = setInterval(() => {
    const status = kitFormStatus(formId);
    if (status === FieldSetStatus.SUBMITTING && Date.now() - startedAt < timeoutMs) {
      return;
    }
    clearInterval(timer);
    onSettled(status);
  }, intervalMs);
  return (): void => clearInterval(timer);
}
